import List from '@components/List/next';

import { BookerResultList } from './BookerResultList';
import { BookerSearchViewModel } from './BookerSearchViewModel';

interface StyledListProps {
  data: BookerSearchViewModel[];
  searchText: string;
  onChange: (item: BookerSearchViewModel) => void;
  callBack?: (item: BookerSearchViewModel) => void;
  showRemoveButton?: boolean;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  inputLocation?: string;
}

export const StyledList = ({
  data,
  onChange,
  callBack,
  showRemoveButton,
  onRemoveItem,
  inputLocation = '',
}: StyledListProps) => (
  <List
    dataSource={data}
    renderItem={(item: BookerSearchViewModel) => (
      <BookerResultList
        item={item}
        onChange={() => onChange(item)}
        callBack={callBack}
        showRemoveButton={showRemoveButton}
        onRemoveItem={onRemoveItem}
        inputLocation={inputLocation}
      />
    )}
  />
);
